import capitalize from 'lodash/capitalize'

import { sortByStringSelector } from 'data/utils/sortByStringSelector'
import { EXCEPTION_TYPES_NEW } from 'settings/constants/exceptions'
import { SERVICE_ACTION_TYPE, RECURRING_COLLECTION_ID, RECURRING_COLLECTION } from 'settings/constants/service'
import T from 'T'

export const RECURRING_COLLECTION_OPTION = { id: RECURRING_COLLECTION_ID, value: RECURRING_COLLECTION }

export const ACTIONS_OPTIONS = [...Object.values(SERVICE_ACTION_TYPE).map(action => ({ id: action, value: capitalize(action) }))]

export const ACTIONS_OPTIONS_WITH_RECURRING_COLLECTION = [
  ...sortByStringSelector({ data: ACTIONS_OPTIONS, key: 'value' }),
  RECURRING_COLLECTION_OPTION,
]

export const NO_EXCEPTIONS_OPTION = { id: 'NO_EXCEPTIONS', value: 'No exceptions' }

export const EXCEPTIONS_OPTIONS = [
  ...Object.values(EXCEPTION_TYPES_NEW).map(exception => ({ id: exception, value: capitalize(exception) })),
]

export const PHOTO_IDS = { WITH_PHOTOS: 'WITH_PHOTOS', WITHOUT_PHOTOS: 'WITHOUT_PHOTOS' }

export const PHOTOS_OPTIONS = [
  { id: PHOTO_IDS.WITH_PHOTOS, value: 'With photos' },
  { id: PHOTO_IDS.WITHOUT_PHOTOS, value: 'Without photos' },
]

export const ARTIFACT_IDS = { HAS_VIDEO_ARTIFACT: 'HAS_VIDEO_ARTIFACT' }

export const ARTIFACTS_OPTIONS = [{ id: ARTIFACT_IDS.HAS_VIDEO_ARTIFACT, value: T.HAS_VIDEO_ARTIFACT }]

export const STOP_FILTER_KEY = 'stopFilters'

export const STOP_FILTER = {
  TAGS: 'tags',
  WORK_ORDER_STATUSES: 'workOrderStatuses',
  ACTIONS: 'actions',
  MEASURES: 'measures',
  MATERIALS: 'materials',
  EXCEPTIONS: 'exceptions',
  PHOTOS: 'photos',
  SERVICES: 'services',
  BUSINESS_UNITS: 'businessUnits',
}

export const FORM_MODEL = {
  searchBusinessLineInput: '',
  searchMethodInput: '',
  searchYardInput: '',
  selectedBusinessLines: [],
  selectedMethods: [],
  selectedYards: [],
  selectedTags: [],
  selectedWorkOrderStatuses: [],
  selectedActions: [],
  selectedMeasures: [],
  selectedMaterials: [],
  selectedExceptions: [],
  selectedPhotos: [],
  selectedServices: [],
  selectedBusinessUnits: [],
  selectedArtifacts: [],
  [STOP_FILTER_KEY]: {},
  isFiltersLoading: false,
}

export const UNASSIGNED_ROUTE = {
  id: 'unassigned',
  name: 'Unassigned',
}
